// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n/**\n* Colors\n*/\n.modal_hideCancel__1INIL .ant-btn-outline {\n  display: none; }\n\n.modal_blueColor__3sJ2K .ant-btn-primary {\n  background: #1890ff;\n  border-color: #1890ff; }\n\n.modal_revertButton__2pPsW .ant-modal-confirm-btns > button:nth-child(1) {\n  order: 2;\n  margin-left: 0; }\n\n.modal_revertButton__2pPsW .ant-modal-confirm-btns > button:nth-child(2) {\n  order: 1;\n  margin-right: 8px;\n  border-color: #d9d9d9 !important;\n  color: #595959 !important; }\n", ""]);
// Exports
exports.locals = {
	"hideCancel": "modal_hideCancel__1INIL",
	"blueColor": "modal_blueColor__3sJ2K",
	"revertButton": "modal_revertButton__2pPsW"
};
module.exports = exports;
